<template>
    <div class="background-color-container" id="capture">
        <LoaderOverlay :show="loading" />
        
        <div class="thumbnail-preview" :class="{ 'section-mode': thumbnailSize === 'section' }" :style="[backgroundStyle]">
            <!-- TODO: this have to be changed later to more dynamic logic -->
            <InlineSvg
                v-if="this.thumbnailData.background.style === 'gradient'"
                :style="{color: inlineSvgColor}"
                class="background-image"
                :src="backgroundSvg"
            />
            <div class="mockups-container" :class="[thumbnailData.mockupDetails[0].deviceType.toLowerCase(), thumbnailData.layout.version, thumbnailData.mockupDetails[0].deviceType ,effectiveThumbnailSize, 'align-text-' + largeThumbnailTextPosition]">
                <div v-bind:key="index + '-mockup'" v-for="(mockup, index) in layouts[thumbnailData.layout.type][thumbnailData.layout.version].mockupTypes" :class="`mockup-container mockup-${index} ${mockup.type} ${getImageSrc(mockup.type, index).isDefault ? '' : 'uploaded-image'}`">
                    <Mockup
                        :svg-src="getMockupSrc(thumbnailData.mockupDetails[index])"
                        :image-src="getImageSrc(mockup.type, index).image"
                        :mockup="thumbnailData.mockupDetails[index]"
                        :isThumbnail="true"
                    />
                    <div v-if="interactive" class="interactions-container">
                        <div class="button-wrapper">
                            <TertiaryButton :dark-scheme="true" :size="getSize(mockup.size)" icon="upload" text="Upload" @click="() => onUploadClick(index)" />
                            <TertiaryButton :dark-scheme="true" :size="getSize(mockup.size)" icon="crop" text="Crop" v-if="imageIndexed(index).url" @click="() => setModalState('crop', index, 'mockup')" />
                        </div>
                        <input v-if="useInlineUpload" id="og-image" type="file" @change="uploadImage($event)" accept="image/png, image/jpeg, image/webp">
                    </div>
                </div>
            </div>
            <div v-if="showHelperText" data-html2canvas-ignore="true" class="helper-text project-name" :class="[largeThumbnailTextPosition, $store.state.portfolio.templateSettings.projectTitle.alignment.vertical]">
                <div class="ufo--project-title-container">
                    <div class="project-title">{{ convertRichTextHTMLToPlainText(projectName) }}</div>
                </div>
                <div class="ufo--project-title-container">
                    <div v-if="!templateSettings.projectTitle.hideDescription" class="project-subtitle">{{ convertRichTextHTMLToPlainText(projectSubtitle) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import InlineSvg from "vue-inline-svg";
import {generateSuggestedColors} from "../../helpers.js";
import Mockup from "../Mockup.vue";
import LoaderOverlay from '../../LoaderOverlay.vue';

//background style svgs
import radial_1 from "../../../../images/thumbnail-generation/background_styles/background-gradient-radial-1.svg";
import linear_1 from "../../../../images/thumbnail-generation/background_styles/background-gradient-linear-1.svg";
import linear_2 from "../../../../images/thumbnail-generation/background_styles/background-gradient-linear-2.svg";
import linear_3 from "../../../../images/thumbnail-generation/background_styles/background-gradient-linear-3.svg";

//Placeholders
import mobile_placeholder from "../../../../images/thumbnail-generation/default-images/mobile-placeholder-aspect.png";
import laptop_placeholder_v1 from "../../../../images/thumbnail-generation/default-images/laptop-placeholder-aspect-v1.png";
import laptop_placeholder_v2 from "../../../../images/thumbnail-generation/default-images/laptop-placeholder-aspect-v2.png";
import tablet_placeholder from "../../../../images/thumbnail-generation/default-images/tablet-placeholder-aspect.png";
import desktop_placeholder from "../../../../images/thumbnail-generation/default-images/desktop-placeholder-aspect.png";
import {SuggestedColorsEnum, ThumbnailBackgroundStyle} from "../../enums.js";
import TertiaryButton from "@/scripts/common/components/TertiaryButton.vue";
import ProjectsAPI from "@/scripts/api/projects/ProjectsAPI.js";
import {findMockup} from "@/scripts/common/mockupStore/mockupStore.js";
import {getExtensionFromMimeType, getMimeType} from "@/scripts/common/utilities/utils.js";
import {resolveNonHexColor} from "@/scripts/common/utilities/colorUtils.js";
import {mapGetters} from "vuex";
import {convertRichTextHTMLToPlainText} from "../textEditor/utilities/textConverterUtilities.js";

//Default placeholder images for mockups. We can add more later if we want to
const defaultImages = {
    mobile:mobile_placeholder,
    laptop:{
        v1:laptop_placeholder_v1,
        v2:laptop_placeholder_v1,
        v3:laptop_placeholder_v2

    },
    tablet:tablet_placeholder,
    desktop:desktop_placeholder
}

const backgroundSvgs = {
    radial_1: radial_1,
    linear_1: linear_1,
    linear_2: linear_2,
    linear_3: linear_3
}

export default {
    name: "ThumbnailImagePreview",
    components: {
        TertiaryButton,
        InlineSvg,
        Mockup,
        LoaderOverlay
        
    },
    props: {
        thumbnailData: {
            type: Object,
            required: true
        },
        setModalState: {
            type: Function,
            default: () => {}
        },
        layouts: {
            type: Object,
            required: true
        },
        thumbnailSize: {
            type: String,
            default: 'small'
        },
        updateImageList: {
            type: Function,
            default: () => {}
        },
        project: {
            type: Object,
            default: null
        },
        interactive: {
            type: Boolean,
            default: true
        },
        useInlineUpload: {
            type: Boolean,
            default: true
        },
        showHelperTextOverride: {
            default: null
        }
    },
    data() {
        return {
            placeholder: mobile_placeholder,
            uploadIndex: null,
            loading: false
        }
    },
    methods: {
        convertRichTextHTMLToPlainText,
        getImageSrc(layoutType, imageNum) {
            let isDefault = true;
            //If there is cropped return else url, if nothing then placeholder
            if(this.thumbnailData.images[imageNum]) {
                if(this.thumbnailData.images[imageNum].cropped && this.thumbnailData.images[imageNum].cropped.url) {
                    isDefault = false
                    return {image:this.thumbnailData.images[imageNum].cropped.url, isDefault: isDefault};
                }
                if(this.thumbnailData.images[imageNum].url) {
                    isDefault = false
                    return {image:this.thumbnailData.images[imageNum].url, isDefault: isDefault}
                }
            }
            let defaultImage = layoutType === 'laptop' ? this.versionedDefaultImage(layoutType) : defaultImages[layoutType.toLowerCase()];
            return {image:defaultImage, isDefault:isDefault}
        },
        getMockupSrc(mockup) {
            return findMockup(
                mockup.deviceType,
                mockup.mockupType,
                mockup.version,
                mockup.colorScheme,
                mockup.settings,
                mockup.orientation
            );
        },
        imageIndexed(index) {
            if(!this.thumbnailData.images[index]) {
                this.updateImageList(index)
                return {url:null, cropped:{url:null, coordinates:null }}
            } else {
                return this.thumbnailData.images[index]
            }
        },
        getSize(size) {
            if(this.effectiveThumbnailSize === 'large') {
                return 'icon'
            }
            else {
                return size === 'small' ? 'icon' : size === 'large' ? 'default' : 'small'
            }
        },
        triggerFileInput(index) {
            this.uploadIndex = index;
            document.getElementById("og-image").click();
        },
        onUploadClick(index) {
            if (this.useInlineUpload) {
                this.triggerFileInput(index);
                return;
            }
            this.setModalState('fileUpload', index, 'mockup');
        },
        async uploadImage(event) {
            this.loading = true; 
            let file = event.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.addEventListener("load", async () => {
                try {
                    let fileType = getMimeType(reader.result)
                    let extension = getExtensionFromMimeType(fileType);
                    let filesToDelete = this.filesToDelete(this.uploadIndex);
                    let response = await ProjectsAPI.uploadThumbnailImage(
                        this.$store.state.user._id,
                        this.project._id,
                        reader.result,
                        "thumbnail-iamge-" + this.uploadIndex,
                        extension,
                        filesToDelete
                    )

                    this.thumbnailData.images[this.uploadIndex].url = response.data.url;
                    this.thumbnailData.images[this.uploadIndex].cropped = {
                        url:null,
                        coordinates: null
                    }
                    this.setModalState('crop', this.uploadIndex);
                    this.uploadIndex = null;
                }
                catch(e) {
                    let errorMessage = "Failed to upload image."
                    if(e.response.status === 413) {
                        const fileSizeMB = (file.size / (1024 * 1024)).toFixed(1);  // Calculate file size in MB
                        errorMessage = `Image is too large (${fileSizeMB} MB). The size limit is 5 MB.`;
                    }
                    this.$store.commit("showAlertMessage", {
                        type:'alert',
                        message: `${errorMessage}`,
                    })
                }
                finally {
                    this.loading = false; 
                }
            }, false);
        },
        filesToDelete(index) {
            let filesToDelete = [];

            if(this.thumbnailData.images[index].url) {
                filesToDelete.push(this.thumbnailData.images[index].url)
            }

            if(this.thumbnailData.images[index].cropped.url) {
                filesToDelete.push(this.thumbnailData.images[index].cropped.url)
            }
            return filesToDelete;
        },
        versionedDefaultImage(type) {
            return defaultImages[type.toLowerCase()][this.thumbnailData.mockupDetails[0].version]
        },
    },
    computed: {
        effectiveThumbnailSize() {
            return this.thumbnailSize === 'section' ? 'small' : this.thumbnailSize;
        },
        ...mapGetters("design", ["colorPalette"]),
        suggestedColorsUsed() {
            return this.thumbnailData?.background?.color && !this.thumbnailData.background.color.startsWith('#') && Object.values(SuggestedColorsEnum).includes(this.thumbnailData.background.color)
        },
        suggestedColorOptions() {
            return generateSuggestedColors(this.colorStyles, this.$store.state.portfolio.designSettings.colorPalette)
        },
        colorStyles() {
            return this.$store.state.portfolio.designSettings.colorStyles
        },
        //Set background style based on the settings the user provided
        inlineSvgColor() {
            return this.suggestedColorsUsed
                ? this.suggestedColorOptions[this.thumbnailData.background.style.match(/^[^_]*/)[0]][this.thumbnailData.background.color][0]
                : resolveNonHexColor(this.thumbnailData.background.color, this.colorPalette);
        },
        backgroundStyle() {
            let style = {};

            //Solid color just returns the fixed color
            if(this.thumbnailData.background.style === ThumbnailBackgroundStyle.SOLID_COLOR) {
                style['background-color'] = this.suggestedColorsUsed
                    ? this.suggestedColorOptions[this.thumbnailData.background.style.match(/^[^_]*/)[0]][this.thumbnailData.background.color][0]
                    : resolveNonHexColor(this.thumbnailData.background.color, this.colorPalette);
            }
            else if(this.thumbnailData.background.style === ThumbnailBackgroundStyle.TRANSPARENT) {
                style['background-color'] = 'transparent';
            }
            //Gradient with multiple options
            else if(this.thumbnailData.background.style === ThumbnailBackgroundStyle.GRADIENT) {
                style['background-color'] = this.suggestedColorsUsed
                    ? this.suggestedColorOptions[this.thumbnailData.background.style.match(/^[^_]*/)[0]][this.thumbnailData.background.color][1]
                    : resolveNonHexColor(this.thumbnailData.background.accentColor, this.colorPalette);
            }else if(this.thumbnailData.background.style === ThumbnailBackgroundStyle.UPLOAD_IMAGE) {
                const imageUrl = this.thumbnailData.background.image?.cropped?.url || this.thumbnailData.background.image?.url;
                if (imageUrl) {
                    style['background-image'] = `url(${imageUrl})`;
                    style['background-size'] = 'cover';
                    style['background-position'] = 'center';
                } else {
                    style['background-color'] = 'var(--asphalt90)';
                }
            }else if(this.thumbnailData.background.style === ThumbnailBackgroundStyle.CURATED_BACKGROUNDS) {
                const imageUrl = this.thumbnailData.background.image?.url;
                if (imageUrl) {
                    style['background-image'] = `url(${imageUrl})`;
                    style['background-size'] = 'cover';
                    style['background-position'] = 'center';
                } else {
                    style['background-color'] = 'var(--asphalt90)';
                }
            }else {
                //Fallback
                style['background-color'] = '#FFFFFF';
            }

            return style;
        },
        largeThumbnailTextPosition() {
            let templateSettings = this.$store.state.portfolio.templateSettings;
            if(templateSettings.tileDisplayMode === 'large' &&
                templateSettings.projectTitle.placement === 'on-thumbnail' &&
                templateSettings.projectTitle.visibility === 'visible') {
                return templateSettings.projectTitle.alignment.horizontal
            }
            else {
                return 'center'
            }
        },
        showHelperText() {
            if (typeof this.showHelperTextOverride === "boolean") {
                return this.showHelperTextOverride;
            }
            let templateSettings = this.$store.state.portfolio.templateSettings;
            return templateSettings.tileDisplayMode === 'large' && templateSettings.projectTitle.placement === 'on-thumbnail' && templateSettings.projectTitle.visibility === 'visible'
        },
        backgroundSvg() {
            if(this.thumbnailData.background.style === 'gradient') {
                return backgroundSvgs[this.thumbnailData.background.gradient]
            }
            return ''
        },
        templateSettings() {
            return this.$store.state.portfolio.templateSettings;
        },
        projectName() {
            if (!this.project) return '';
            let headerTitle = this.project.sections[0];
            return this.project.name !== null ? this.project.name : headerTitle.title.text
        },
        projectSubtitle() {
            if (!this.project) return '';
            let headerSubtitle = this.project.sections[0];
            return this.project.subtitle !== null ? this.project.subtitle : headerSubtitle.subtitle.text
        },
    }
}
</script>

<style lang="scss">
    .thumbnail-preview {
        .mockups-container {
            .mockup-container {
                .mockup-svg-container {
                    svg {
                        width: auto;
                    }
                }
            }
        }
    }
</style>

<style scoped lang="scss">

.background-color-container {
    .thumbnail-preview {
        position: relative;
        background-repeat: no-repeat;
        overflow: hidden;

        //Helper text
        .project-name {
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            text-align: center;
            z-index: 2;
            width: 100%;
            height: 100%;
            padding: 25px;

            &.top {
                justify-content: flex-start;
            }

            &.bottom {
                justify-content: flex-end;
            }

            &.left {
                align-items: flex-start;
                text-align: left;
            }

            &.right {
                align-items: flex-end;
                text-align: right;
            }

            .ufo--project-title-container {
                max-width: 50%;
            }

            --text-size-mult: .38;

            .project-title {
                font-family: var(--thumbnail-title-font);
                font-size: clamp(var(--min-hl-size), calc( var(--thumbnail-title-size) * var(--text-size-mult)), var(--thumbnail-title-size));
                font-weight: var(--thumbnail-title-weight);
                font-style: var(--thumbnail-title-style);
                line-height: normal;
                color: var(--thumbnail-title-text-color);
                margin-bottom: 16px;
            }
            .project-subtitle {
                font-family: var(--thumbnail-subtitle-font);
                font-size: clamp( var(--min-pg-size), calc( var(--thumbnail-subtitle-size) * var(--text-size-mult) ), var(--thumbnail-subtitle-size) );
                font-weight: var(--thumbnail-subtitle-weight);
                font-style: var(--thumbnail-subtitle-style);
                line-height: normal;
                color: var(--thumbnail-subtitle-text-color);
                margin-bottom: 0px;
            }
        }

        .background-image {
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .mockups-container {
            z-index: 3;

            .desktop {
                .interactions-container {
                    height: 70% !important;
                }
            }

            &.small {
                width: 368px;
                height: 368px;
                margin: auto;
            }

            &.medium {
                width: 319px;
                height: 319px;
                margin: auto;

                //Edge case, when mockup is on the side, we have to push to right

                &.laptop {
                    &.single_slided {
                        margin-left: 50px;
                    }

                    &.mobile_middle {
                        margin-left: 50px;
                    }
                }

            }

            &.large {
                width: 217px;
                height: 218px;
                margin: auto;
            }

            position: relative;

            svg {
                display: block;
            }


            .mockup-container {
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                position: absolute;
                width: fit-content;
                margin: auto;

                &:hover {
                    cursor: pointer;
                }


                &.uploaded-image {
                    .interactions-container {
                        opacity: 0;
                    }
                }

                &:hover {
                    .interactions-container {
                        opacity: 1;
                    }
                }

                .interactions-container {
                    transition: opacity 0.5s ease;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 2;
                    pointer-events: none;

                    input[type="file"] {
                        display: none;
                    }

                    .button-wrapper {
                        position: relative;
                        z-index: 1;
                        display: flex;
                        width: 94px;
                        flex-direction: column;
                        align-items: center;
                        gap: 12px;
                        pointer-events: auto;
                    }
                }

                .thumbnail-image-upload-fabs {
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: none;
                    .ufo-fab {
                        width: 36px;
                        height: 36px;
                    }
                    &.empty {
                        display: block;
                    }
                }
                &.visible,
                &:hover {
                    .thumbnail-image-upload-fabs {
                        display: block;
                    }
                }

                .mockup-svg {
                    width: auto;
                    height: 100%;
                    position: relative;
                    z-index: 1;
                }
            }

            &.tablet .mockup-container {
                height: 90%;
            }

            &.laptop .mockup-container {
                height: 61%;
            }

            &.mobile .mockup-container {
                height: 79%;
            }

            &.desktop .mockup-container {
                height: 78%;
            }

            &.small {
                overflow: hidden;
            }

            &.mobile {
                &.single_slided {
                    .mockup-container {
                        height: 125%;
                        top: 40%;
                    }
                }
                &.dual_middle {

                    .mockup-1 {
                        left: 40%;
                    }

                    .mockup-0 {
                        right: 40%;
                    }
                }
                &.dual_slided {

                    .mockup-1 {
                        bottom:10%;
                        left: 40%;
                    }

                    .mockup-0 {
                        top: 10%;
                        right: 40%;
                    }
                }
                &.triple_middle {
                    .mockup-1 {
                        height: 51%;
                        right: 68%;
                    }

                    .mockup-2 {
                        height: 51%;
                        left: 68%;
                    }


                }
                &.triple_middle_horizontal {
                    .mockup-1 {
                        left: 72%;
                    }

                    .mockup-2 {
                        right: 72%;
                        left: unset;
                    }
                }
                &.triple_slided {
                    .mockup-0 {
                        right: 43%;
                    }

                    .mockup-1 {
                        left: 43%;
                        bottom: 80%;
                    }

                    .mockup-2 {
                        left: 43%;
                        top: 80%;
                    }

                    &.browser {
                        .mockup-1 {
                            bottom: 83%;
                        }

                        .mockup-2 {
                            top: 83%;
                        }
                    }

                }
                &.triple_slided_rotated {
                    .mockup-container {
                        transform: rotate(-30deg);
                    }
                    .mockup-0 {
                        right: 33%;
                        top: 20%;
                    }

                    .mockup-1 {
                        bottom: 91%;
                        left: -2%;
                    }

                    .mockup-2 {
                        left: 69%;
                        top: 47%;
                    }

                    &.browser {
                        .mockup-1 {
                            bottom: 90%;
                            left: -10%;
                        }

                        .mockup-2 {
                            left: 65%;
                            top: 48%;
                        }
                    }

                    &.no_device {
                        .mockup-1 {
                            bottom: 87%;
                            left: -8%;
                        }
                        .mockup-2 {
                            left: 64%;
                            top: 44%;
                        }
                    }
                }
                &.quadruple_slided {
                    .mockup-0 {
                        right: 42%;
                        bottom: 62%;
                    }

                    .mockup-1 {
                        bottom: 92%;
                        left: 42%;
                    }

                    .mockup-2 {
                        left: 42%;
                        top: 67%;
                    }
                    .mockup-3 {
                        right: 42%;
                        top: 92%;
                    }

                    &.browser {
                        .mockup-2 {
                            top: 70%;
                        }
                        .mockup-3 {
                            top: 100%;
                        }
                    }

                    &.no_device {
                        .mockup-2 {
                            top: 60%;
                        }
                        .mockup-3 {
                            top: 90%;
                        }
                    }
                }
                &.quadruple_slided_rotated {
                    .mockup-container {
                        transform: rotate(-30deg);
                    }

                    .mockup-0 {
                        bottom: 72%;
                        right: 43%;
                    }

                    .mockup-1 {
                        bottom: 35%;
                        left: 66%;
                    }

                    .mockup-2 {
                        left: 38%;
                        top: 66%;
                    }
                    .mockup-3 {
                        left: unset;
                        right: 66%;
                        top: 40%;
                    }

                    &.browser {
                        .mockup-0 {
                            bottom: 75%;
                            right: 45%;
                        }
                        .mokup-2 {
                            left: 340%;
                            top: 68%;
                        }
                    }

                    &.no_device {
                        .mockup-0 {
                            bottom: 70%;
                            right: 41%;
                        }
                        .mokup-2 {
                            left: 36%;
                            top: 64%;
                        }
                    }
                }
            }

            &.laptop {
                &.single_slided {
                    .mockup-container {
                        height: 71%;
                    }

                    .mockup-0 {
                        left: 5%;
                    }

                    &.no_device, &.browser {
                        .mockup-0 {
                            left: 15%;
                        }
                    }
                }
                &.mobile_overlay {
                    .mockup-0 {
                        height: 55%;
                        right: 5%;
                    }
                    .mockup-1 {
                        img {
                            z-index: 1;
                        }
                        height: 45%;
                        left: 51%;
                        top: 14%;
                    }
                }
                &.mobile_middle {
                    .mockup-0 {
                        height: 65%;
                        left: 31%;
                    }
                    .mockup-1 {
                        height: 50%;
                        right: 62%;
                    }
                }
                &.single_slided_big  {
                    .mockup-0 {
                        height: 105%;
                        left: -2%;
                        top: 22%;
                    }

                    &.no_device, &.browser {
                        .mockup-0 {
                            left: -7%;
                            top: 10%;
                        }
                    }
                }
                &.triple_variety {
                    .mockup-0 {
                        height: 50%;
                        right: 10%;
                    }
                    .mockup-1 {
                        height: 45%;
                        z-index: 1;
                        left: 47%;
                        top: 17%;
                    }

                    .mockup-2 {
                        height: 35%;
                        top: 35%;
                        left: 74%;
                        z-index: 2;
                    }
                }
            }

            &.tablet {
                &.single_slided {
                    .mockup-container {
                        height: 117%;
                        top: 30%;
                    }
                }
                &.mobile_overlay {
                    .mockup-0 {
                        top: -1%;
                    }
                    .mockup-1 {
                        img {
                            z-index: 1;
                        }
                        height: 58%;
                        top: 36%;
                        left: 59%;
                    }
                }
                &.mobile_middle {
                    .mockup-0 {
                        left: 29%;
                    }
                    .mockup-1 {
                        right: 66%;
                        height: 50%;
                    }
                }
                &.single_slided_big  {
                    .mockup-0 {
                        height: 160%;
                        left: 5%;
                        top: 67%;
                    }

                    &.brower {
                        .mockup-0 {
                            left: 5%
                        }
                    }
                    &.no_device {
                        .mockup-0 {
                            left: 15%;
                        }
                    }
                }
            }

            &.desktop {
                &.single_middle {
                    &.browser {
                        .mockup-0 {
                            height: 71%;
                        }
                    }
                }
                &.mobile_middle {
                    .mockup-0 {
                        height: 60%;
                        right: 15%;
                    }

                    .mockup-1 {
                        height: 36%;
                        z-index: 1;
                        left: 54%;
                        top: 30%;
                    }

                    &.no_device, &.browser {
                        .mockup-0 {
                            height: 61%;
                        }
                    }
                }

                &.tablet_middle {
                    .mockup-0 {
                        height: 60%;
                        right: 15%;
                    }

                    .mockup-1 {
                        height: 45%;
                        z-index: 1;
                        left: 55%;
                        top: 25%;
                    }

                    &.no_device, &.browser {
                        .mockup-0 {
                            height: 61%;
                        }
                    }
                }

                &.desktop_middle {
                    .mockup-0 {
                        height: 60%;
                        right: 15%;
                    }

                    .mockup-1 {
                        height: 31%;
                        z-index: 1;
                        left: 48%;
                        top: 34%;
                    }

                    &.no_device, &.browser {
                        .mockup-0 {
                            height: 61%;
                        }
                    }
                }

                &.triple_variety {
                    .mockup-0 {
                        height: 60%;
                        right: 15%;
                    }

                    .mockup-1 {
                        height: 45%;
                        z-index: 1;
                        left: 47%;
                        top: 25%;
                    }

                    .mockup-2 {
                        height: 36%;
                        top: 41%;
                        left: 74%;
                        z-index: 2;
                    }

                    &.no_device, &.browser {
                        .mockup-0 {
                            height: 61%;
                        }
                    }
                }

                &.quadruple_variety {
                    .mockup-0 {
                        height: 60%;
                    }

                    .mockup-1 {
                        height: 45%;
                        z-index: 1;
                        left: 55%;
                        top: 27%;
                    }

                    .mockup-2 {
                        height: 34%;
                        top: 42%;
                        left: 78%;
                        z-index: 2;
                    }

                    .mockup-3 {
                        height: 36%;
                        right: 40%;
                        top: 34%;
                        z-index: 2;
                    }

                    &.no_device, &.browser {
                        .mockup-0 {
                            height: 61%;
                        }
                    }
                }
            }

            //size specific positions
            //Need to tweak for large a bit
            &.large {
                //Align mockup based on text position in inside mockup
                &.align-text-left {
                    margin-right: 0;

                    &.laptop {
                        &.single_slided {
                            margin-right: -10px;
                        }
                        &.single_slided_big {
                            margin-right: -25px;
                        }
                    }

                    &.tablet {
                        &.mobile_middle {
                            margin-right: 15px;
                        }
                        &.single_slided_big {
                            margin-right: -20px;
                        }
                    }

                }

                &.align-text-right {
                    margin-left: 0;
                    &.laptop {
                        &.mobile_middle {
                            transform: scaleX(-1);
                            .mockup-container {
                                transform: scaleX(-1);
                            }
                        }
                        &.single_slided {
                            margin-left: -30px;

                        }
                        &.single_slided_big {
                            margin-left: -25px;
                        }
                    }
                    &.tablet {
                        &.mobile_middle {
                            transform: scaleX(-1);
                            margin-left: 15px;
                            .mockup-container {
                                transform: scaleX(-1);
                            }
                        }

                        &.single_slided_big {
                            margin-left: -25px;
                        }
                    }
                }

                &.tablet {
                    &.single_slided_big {
                        .mockup-0 {
                            height: 140%;
                            left: 5%;
                            top: 65%;
                        }
                    }
                    &.mobile_middle {
                        .mockup-0 {
                            left: 50%;
                        }

                        .mockup-1 {
                            right: 50%;
                        }
                    }
                }
                &.laptop {
                    &.single_slided_big {
                        .mockup-0 {
                            height: 90%;
                            top: 25%;
                            left: -20%;
                        }
                    }

                    &.mobile_middle {
                        .mockup-0 {
                            left: 25%;
                        }
                        .mockup-1 {
                            right: 100%;
                        }
                    }
                }

                &.desktop {
                    &:not(.align-text-right):not(.align-text-left) {
                        &.quadruple_variety {
                            .mockup-0 {
                                height: 60%;
                            }

                            .mockup-1 {
                                left: 70%;
                            }

                            .mockup-2 {
                                top: 45%;
                                left: 92%;
                            }
                            .mockup-3 {
                                left: unset;
                                right: 66%;
                            }

                            &.no_device, &.browser {
                                .mockup-0 {
                                    height: 45%;
                                }
                            }
                        }
                    }
                }
            }

            &.medium {
                &.mobile {
                    &.triple_middle_horizontal {
                        .mockup-1 {
                            left: 78%;
                        }
                        .mockup-2 {
                            right: 78%;
                        }
                    }
                }
                &.laptop {
                    &.single_slided_big {
                        margin-left: 80px;
                    }
                    &.single_slided {
                        margin-left: 80px;
                    }
                }

                &.tablet {
                    &.single_slided_big {
                        margin-left: 80px;
                    }
                }
            }
        }
    }

    .thumbnail-preview.section-mode {

        .mockups-container {
            width: 100%;
            height: 100%;
            margin: auto;
            aspect-ratio: 1 / 1;
            max-height: 442px;
            max-width: 442px;
            overflow: initial;
        }
    }

    .thumbnail-preview:not(.section-mode) {
        .mockup-container {
            :deep(.mockup-screen .wrapper) {
                position: relative;
            }

            :deep(.mockup-screen .wrapper::after) {
                content: "";
                position: absolute;
                inset: 0;
                background-color: rgba(0, 0, 0, 0.12);
                backdrop-filter: blur(4px);
                -webkit-backdrop-filter: blur(4px);
                opacity: 0;
                transition: opacity 0.5s ease;
                pointer-events: none;
                z-index: 1;
                border-radius: inherit;
            }

            :deep(.mockup-screen-overlay) {
                opacity: 0;
                transition: opacity 0.5s ease;
                pointer-events: none;
            }

            &:hover :deep(.mockup-screen .wrapper::after),
            &:hover :deep(.mockup-screen-overlay) {
                opacity: 1;
            }
        }
    }

}

</style>
